import type { AllHTMLAttributes, AriaAttributes, DOMAttributes, HTMLAttributes } from 'react';
import type { GlobalAttributes } from './constants.js';
import { globalAttributes } from './constants.js';

export type GlobalAttributesT<T = Element> = Omit<
  AriaAttributes &
    DOMAttributes<T> &
    HTMLAttributes<T> &
    Omit<AllHTMLAttributes<T>, 'as'> & { tabIndex?: WCAGTabIndex },
  'dangerouslySetInnerHTML'
>;

export const getGlobalAttributes = <T, S = Element>(
  props: T,
  overrides?: Partial<GlobalAttributes<CallableFunction>>,
): GlobalAttributesT<S> => {
  const globalAttributesObject: GlobalAttributesT<S> = {};
  Object.entries(props as Record<string, unknown>).forEach(([key, value]) => {
    if (key in globalAttributes || key.startsWith('data-')) {
      if (
        overrides &&
        key in overrides &&
        typeof value === 'function' &&
        typeof overrides[key as keyof GlobalAttributes] === 'function'
      ) {
        const newFunc = (...args: unknown[]) => {
          (value as CallableFunction)(...args);
          (overrides[key as keyof GlobalAttributes] as CallableFunction)(...args);
        };
        globalAttributesObject[key as keyof GlobalAttributesT] = newFunc as unknown as T[keyof T];
      } else {
        // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
        globalAttributesObject[key as keyof GlobalAttributesT] = value;
      }
    }
  });
  return globalAttributesObject;
};
